import { render, staticRenderFns } from "./PlanogramShelf.vue?vue&type=template&id=2541555e&scoped=true"
import script from "./PlanogramShelf.vue?vue&type=script&lang=js"
export * from "./PlanogramShelf.vue?vue&type=script&lang=js"
import style0 from "./PlanogramShelf.vue?vue&type=style&index=0&id=2541555e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2541555e",
  null
  
)

export default component.exports